<!-- Сплошная иконка календаря для тёмного бокового меню. -->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fill-rule="evenodd"
      fill="currentColor"
      d="M5.5 4.5H18.5A2.5 2.5 0 0 1 21 7V18.5A2.5 2.5 0 0 1 18.5 21H5.5A2.5 2.5 0 0 1 3 18.5V7A2.5 2.5 0 0 1 5.5 4.5ZM7.1 11H8.9A.6.6 0 0 1 9.5 11.6V13A.6.6 0 0 1 8.9 13.6H7.1A.6.6 0 0 1 6.5 13V11.6A.6.6 0 0 1 7.1 11ZM11.1 11H12.9A.6.6 0 0 1 13.5 11.6V13A.6.6 0 0 1 12.9 13.6H11.1A.6.6 0 0 1 10.5 13V11.6A.6.6 0 0 1 11.1 11ZM15.1 11H16.9A.6.6 0 0 1 17.5 11.6V13A.6.6 0 0 1 16.9 13.6H15.1A.6.6 0 0 1 14.5 13V11.6A.6.6 0 0 1 15.1 11ZM7.1 15.5H8.9A.6.6 0 0 1 9.5 16.1V17.5A.6.6 0 0 1 8.9 18.1H7.1A.6.6 0 0 1 6.5 17.5V16.1A.6.6 0 0 1 7.1 15.5ZM11.1 15.5H12.9A.6.6 0 0 1 13.5 16.1V17.5A.6.6 0 0 1 12.9 18.1H11.1A.6.6 0 0 1 10.5 17.5V16.1A.6.6 0 0 1 11.1 15.5Z"
    />
    <path
      fill="currentColor"
      d="M8 1.5A1 1 0 0 1 9 2.5V5.5A1 1 0 0 1 7 5.5V2.5A1 1 0 0 1 8 1.5ZM16 1.5A1 1 0 0 1 17 2.5V5.5A1 1 0 0 1 15 5.5V2.5A1 1 0 0 1 16 1.5Z"
    />
  </svg>
</template>

<script>
export default {
  name: "CalendarNavIcon",

  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
  },
};
</script>
